import fetch from '../../api/fetch'

/**
 * 	Action to post data for step03
 *
 *  @param  {object} content [Body to be sent with step03 content]
 *  @param  {string} URL [/quotes/step03]
 * 	@method POST
 */
export function setStep03(content: any) {
    return {
        type: 'SET_STEP03',
        payload: fetch(`/quotes/step03`, { method: 'POST', body: content }),
        quoteId: content.quote.id,
    }
}

/**
 * 	Action to post data for step03
 *
 *  @param  {object} content [Body to be sent with step03 content]
 *  @param  {string} URL [/quotes/step03]
 * 	@method POST
 */
export function setStep03Renewals(content: any) {
    return {
        type: 'SET_STEP03',
        payload: fetch(`/renewal/step03`, { method: 'POST', body: content }),
        quoteId: content.quote.id,
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/step03.ts